import { flexCenterSx, marginTop24Sx } from '../../styles/Global.style';

export const toggleSwitchContainerSx = {
  ...flexCenterSx,
  ...marginTop24Sx,
};

export const distanceInputAdornmentSx = (theme) => ({
  '.MuiTypography-root': {
    color: theme.palette.secondary.main,
  },
});

export const charCountContainerSx = { margin: '0 0 16px 0' };

export const charCountSx = {
  fontSize: '14px',
  color: '#71767b',
  textAlign: 'right',
};
